import React from 'react';

function FlagIconKz({ w, h, style, className }) {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={`${w}px`}
      height={`${h}px`}
      viewBox="0 0 512 512"
      className={className}
      style={style}
    >
      <circle fill="#338AF3" cx="256" cy="256" r="256" />
      <path
        fill="#FFDA44"
        d="M400.696,258.783H111.304c0,19.979,17.401,36.174,37.378,36.174h-1.204c0,19.979,16.195,36.174,36.174,36.174c0,19.979,16.195,36.174,36.174,36.174h72.348c19.979,0,36.174-16.195,36.174-36.174c19.979,0,36.174-16.195,36.174-36.174h-1.204C383.293,294.957,400.696,278.762,400.696,258.783z"
      />
      <path
        fill="#338AF3"
        d="M356.174,211.478c0,55.324-44.85,100.174-100.174,100.174c-55.325,0-100.174-44.85-100.174-100.174"
      />
      <polygon
        fill="#FFDA44"
        points="332.515,211.478 301.25,226.185 317.899,256.465 283.949,249.97 279.647,284.266 256,259.041 232.352,284.266 228.051,249.97 194.101,256.463 210.749,226.184 179.485,211.478 210.75,196.772 194.101,166.493 228.05,172.987 232.353,138.691 256,163.916 279.648,138.691 283.949,172.987 317.9,166.493 301.251,196.773"
      />
    </svg>
  );
}

FlagIconKz.defaultProps = {
  w: 20,
  h: 20,
  style: {},
  fill: '#000',
};

export default FlagIconKz;
